import React from "react";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import AthleteSearchPanel from "../../common/athletes/AthleteSearchPanel";

export default function AthleteCard({ isAdmin = false }) {
  const authUser = useAuthUser();

  return (
    <div className="flex flex-col p-4 pb-0 rounded-md shadow-lg bg-white lg:h-full">
      <p className="text-xl mb-5 uppercase">Athletes</p>
      <AthleteSearchPanel
        authUser={authUser}
        listVariant="chips"
        chipProps={{ isAdmin, showStarButton: false }}
      />
    </div>
  );
}
